<template>
  <v-app>
    <v-content class="pa-0">
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            src="img/bg.jpg"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center mb-4"
                    cols="12"
                    tag="h1"
                    style="background-color: #00000099; border-radius: 25px;"
                  >
                    <span
                      :class="[
                        $vuetify.breakpoint.smAndDown
                          ? 'display-1'
                          : 'display-2'
                      ]"
                      class="font-weight-light"
                    >
                      API de sorteio para o Telegram
                    </span>

                    <br />

                    <span
                      :class="[
                        $vuetify.breakpoint.smAndDown
                          ? 'display-1'
                          : 'display-2'
                      ]"
                      class="font-weight-black"
                    >
                      @SorteadorTelegramBot
                    </span>
                  </v-col>
                  <!--
                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-us')"
                  >
                    <v-icon>fa fa-arrow-down</v-icon>
                  </v-btn>
                  -->
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>
    </v-content>

    <v-footer class="justify-center" color="#292929" height="60">
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >
        &copy; {{ new Date().getFullYear() }} — Vuetify, LLC
      </div>
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'auth',
  components: {},
  data: () => ({}),
  methods: {
    openLink(_url) {
      window.open(_url, '_blank')
    }
  }
}
</script>
